var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-picker"},_vm._l((_vm.itemArray),function(item,index){return _c('button',{key:index,staticClass:"bar-picker-item",class:{ active: _vm.currentSelectedIndex == index },on:{"click":function($event){return _vm.onItemSelected(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }